<template>
    <section class="page-section mb-10 sm:mb-20">
        <div class="container">
            <div class="mt-10 mb-10 sm:mb-12 min-400 border-b border-gray-200 pt-5 pb-12 px-20">
                <h2 class="text-3xl leading-10 font-medium capitalize mb-6">
                    {{ page.title }}
                </h2>
                <div v-if="page.image" class="w-full mt-4 mb-6 rounded-lg overflow-hidden">
                    <img :src="page.image" alt="image">
                </div>
                <div v-html="page.description">
                </div>
            </div>
            <TemplateManagerComponent :menuTemplateId="page.menu_template_id" />
        </div>
    </section>
</template>

<script>
import TemplateManagerComponent from "../components/TemplateManagerComponent.vue";

export default {
    name: "PageComponent",
    components: {TemplateManagerComponent},
    computed: {
        page: function () {
            return this.$store.getters['frontendPage/show'];
        }
    },
    mounted() {
        this.pageSetup();
    },
    methods: {
        pageSetup: function () {
            if (Object.keys(this.$route.params).length > 0 && typeof this.$route.params.slug === 'string') {
                this.$store.dispatch('frontendPage/show', this.$route.params.slug).then().catch()
            }
        }
    },
    watch: {
        $route() {
            this.pageSetup();
        }
    }
}
</script>
